import React from 'react';
const Dashboard = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default Dashboard;